import React, { useEffect, useState } from 'react';
import { Avatar } from 'flowbite-react';
import { revertPositionTitleV2, stringAvatar } from 'shared-utils';
import { generateCompanyLogoAvatarSrc } from 'src/utils/companyLogo';
import { CompanyDocument, UIOfflineDriveRoundDetail } from 'types';
import moment from 'moment';
import DisplayRoom from '../DisplayRoom';
import OpportunityActions from './opportunityTableCell/OpportunityActions';

interface Props {
	applicationRound: UIOfflineDriveRoundDetail;
	driveId: string;
}

function MobileCardForOpportunityTable({ applicationRound, driveId }: Props) {
	const [avatarImg, setAvatarImg] = useState('');
	const generateAvatar = async (data: CompanyDocument) => {
		const res = await generateCompanyLogoAvatarSrc(data?.logo || '', data?.url || '');
		setAvatarImg(res);
	};

	useEffect(() => {
		generateAvatar({
			logo: applicationRound?.company?.logo,
			url: applicationRound?.company?.url || '',
		} as CompanyDocument);
	}, [applicationRound?.company?.logo, applicationRound?.company?.url]);
	return (
		<div
			className={`w-full border border-[#EBEBF0] rounded-[12px] bg-[#FFF] shadow-[0px_1px_2px_rgba(226,226,226,0.00),_0px_1px_3px_rgba(167,167,167,0.09)] flex flex-col box-border pt-4 relative `}
		>
			<div className="flex justify-between px-4">
				<div className="flex flex-1 min-w-[80px] relative">
					<div className="flex items-start gap-2">
						<Avatar
							rounded
							size="md"
							className="text-xl"
							img={avatarImg}
							placeholderInitials={stringAvatar(applicationRound?.company?.name?.trim()?.toUpperCase())}
						/>

						<div className="flex flex-col">
							<div className="flex gap-1 items-center">
								<p className="text-[#1C1C28] font-inter text-base font-medium">{applicationRound?.company?.name}</p>
							</div>
							<div className="flex">
								<p className="text-[#28293D] font-inter text-xs font-medium mt-[4px]">
									{revertPositionTitleV2(applicationRound?.position?.title)}
									<span>
										{applicationRound?.position?.positionLabel ? ` (${applicationRound?.position?.positionLabel})` : ''}
									</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* middle */}

			<div className="py-2.5 flex flex-col gap-2.5 px-4">
				<div className="flex justify-between">
					{/* 1 */}
					<div className="w-[50%]">
						<p className="text-[#555770] text-[10px] font-medium">Salary Offering</p>
						<div className="flex flex-col gap-1 text-[#1F3343]">
							<p className="font-inter text-xs font-medium ">{`${applicationRound?.position?.salary?.min} - ${applicationRound?.position?.salary?.max} LPA`}</p>
						</div>
					</div>
					{/* 2 */}
					<div className="w-[50%]">
						<p className="text-[#555770] text-[10px] font-medium">Round Type</p>
						<div className="flex flex-col gap-1 text-[#1F3343]">
							<p className="font-inter text-xs font-medium ">{applicationRound?.customLabel}</p>
						</div>
					</div>
				</div>
				<div className="flex justify-between">
					{/* 1 */}
					<div className="w-[50%]">
						<p className="text-[#555770] text-[10px] font-medium">BD POC</p>
						<div className="flex flex-col gap-1 text-[#1F3343]">
							<p className="font-inter text-xs font-medium ">{`${applicationRound?.company?.bdPoc?.name}`}</p>
						</div>
					</div>
					{/* 2 */}
					<div className="w-[50%]">
						<p className="text-[#555770] text-[10px] font-medium">Created At</p>
						<div className="flex flex-col gap-1 text-[#1F3343]">
							<p className="font-inter text-xs font-medium ">
								{moment(applicationRound?.roundCreatedAt)?.format('D MMM, hh:mma')}
							</p>
						</div>
					</div>
				</div>
			</div>

			{/* footer card */}
			<div className="inline-flex p-[7px_10.73px_6px_15px] justify-between items-center gap-9 rounded-b-[12px] border-t-[1px] border-t-[#EBEBF0]">
				<div className="flex flex-col">
					<div>
						<DisplayRoom offlineDriveRoom={applicationRound?.company?.offlineDriveRoom} />
					</div>
				</div>
				<div>
					<OpportunityActions driveId={driveId} applicationRound={applicationRound} />
				</div>
			</div>
		</div>
	);
}
export default MobileCardForOpportunityTable;
